import { render } from "./Damage.vue?vue&type=template&id=7482cb5d&scoped=true"
import script from "./Damage.vue?vue&type=script&lang=js"
export * from "./Damage.vue?vue&type=script&lang=js"

import "./Damage.vue?vue&type=style&index=0&id=7482cb5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7482cb5d"

export default script